var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMainDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-main-dark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 330,
    height: 80,
    viewBox: "0 0 330 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6119",
    "data-name": "Rectangle 6119",
    width: 80,
    height: 80,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11842",
    "data-name": "Group 11842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11841",
    "data-name": "Group 11841",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18216",
    "data-name": "Path 18216",
    d: "M35.652,96.912a31.33,31.33,0,0,1,2.881-6.046.847.847,0,0,0-.225-1.137l-1.581-1.121a.843.843,0,0,0-1.205.249,35.044,35.044,0,0,0-3.308,6.967.846.846,0,0,0,.559,1.092l1.848.536a.845.845,0,0,0,1.031-.54",
    transform: "translate(-24.369 -67.01)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18217",
    "data-name": "Path 18217",
    d: "M40.291,222.791c.352.51.72,1.017,1.1,1.513a.842.842,0,0,0,1.22.129l1.457-1.254a.847.847,0,0,0,.115-1.158,32.489,32.489,0,0,1-1.9-2.767A30.434,30.434,0,0,1,40.7,216.3a.845.845,0,0,0-1.081-.434l-1.783.72a.847.847,0,0,0-.446,1.145,33.75,33.75,0,0,0,1.825,3.4c.336.558.7,1.131,1.077,1.66",
    transform: "translate(-28.265 -163.487)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18218",
    "data-name": "Path 18218",
    d: "M280.973,234.693a36.288,36.288,0,0,1-4.653,6.676.853.853,0,0,0,.037,1.176l1.518,1.483a.85.85,0,0,0,1.228-.036,39.363,39.363,0,0,0,5.3-7.595.853.853,0,0,0-.393-1.169l-1.919-.908a.857.857,0,0,0-1.12.373",
    transform: "translate(-209.17 -177.453)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18219",
    "data-name": "Path 18219",
    d: "M148.511,315.682l-.276-2.08a.868.868,0,0,0-.923-.755,35.776,35.776,0,0,1-8.122-.268.867.867,0,0,0-.971.693l-.411,2.051a.863.863,0,0,0,.709,1.025,39.587,39.587,0,0,0,9.22.311.862.862,0,0,0,.776-.976",
    transform: "translate(-104.387 -236.795)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18220",
    "data-name": "Path 18220",
    d: "M200.256,303.8l-.946-1.887a.855.855,0,0,0-1.112-.395,35.88,35.88,0,0,1-7.781,2.4.854.854,0,0,0-.694.953l.286,2.1a.852.852,0,0,0,.993.728,39.854,39.854,0,0,0,8.843-2.737.853.853,0,0,0,.41-1.163",
    transform: "translate(-143.724 -228.37)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18221",
    "data-name": "Path 18221",
    d: "M53.246,275.663l1.044-1.8a.871.871,0,0,0-.269-1.166,35.138,35.138,0,0,1-6.254-5.213.864.864,0,0,0-1.19-.053L45,268.793a.864.864,0,0,0-.072,1.244,38.677,38.677,0,0,0,7.109,5.923.86.86,0,0,0,1.208-.3",
    transform: "translate(-33.862 -202.441)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18222",
    "data-name": "Path 18222",
    d: "M97.335,303.334l.411-2.053a.869.869,0,0,0-.629-1.015,36.8,36.8,0,0,1-7.619-2.88.859.859,0,0,0-1.136.329l-1.054,1.816a.864.864,0,0,0,.339,1.2,39.147,39.147,0,0,0,8.641,3.276.861.861,0,0,0,1.047-.672",
    transform: "translate(-66.053 -225.22)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18223",
    "data-name": "Path 18223",
    d: "M174.347.892l-.068,1.982a.919.919,0,0,0,.832.95,36.6,36.6,0,0,1,7.9,1.589.918.918,0,0,0,1.132-.552L184.851,3a.928.928,0,0,0-.586-1.213A39.138,39.138,0,0,0,175.352,0a.926.926,0,0,0-1.005.889",
    transform: "translate(-132.029 0)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18224",
    "data-name": "Path 18224",
    d: "M312.23,135.713a36.085,36.085,0,0,1,.4,8.272.8.8,0,0,0,.7.843l2.233.248a.785.785,0,0,0,.872-.721,39.79,39.79,0,0,0-.475-9.4.785.785,0,0,0-.945-.631l-2.183.482a.8.8,0,0,0-.6.905",
    transform: "translate(-236.53 -101.747)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18225",
    "data-name": "Path 18225",
    d: "M44.913,12.586A39.7,39.7,0,0,0,34.1,22.257a.841.841,0,0,0,.188,1.2l1.756,1.234a.842.842,0,0,0,1.149-.178A36.472,36.472,0,0,1,53.26,12.769a.845.845,0,0,0,.52-1.04l-.63-2.048a.837.837,0,0,0-1.084-.546,40.026,40.026,0,0,0-7.153,3.451",
    transform: "translate(-25.703 -6.882)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18226",
    "data-name": "Path 18226",
    d: "M214.651,36.53l-.624,1.636a.92.92,0,0,0,.475,1.168,31.015,31.015,0,0,1,5.7,3.312.916.916,0,0,0,1.245-.162l1.122-1.355a.928.928,0,0,0-.168-1.339,34.779,34.779,0,0,0-6.509-3.775.925.925,0,0,0-1.24.515",
    transform: "translate(-162.095 -27.224)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18227",
    "data-name": "Path 18227",
    d: "M231.429,255.5a.857.857,0,0,0-1.178-.018,31.237,31.237,0,0,1-4.786,3.56c-.214.133-.416.253-.615.366a.856.856,0,0,0-.344,1.127l.844,1.688a.853.853,0,0,0,1.185.362c.267-.152.535-.307.8-.467a35.58,35.58,0,0,0,5.406-4.044.86.86,0,0,0,.031-1.25Z",
    transform: "translate(-170.012 -193.373)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18228",
    "data-name": "Path 18228",
    d: "M6.292,185.777A35.44,35.44,0,0,1,4.538,177.8a.846.846,0,0,0-.881-.766l-2.148.11a.84.84,0,0,0-.8.917,39.886,39.886,0,0,0,2,9.089.839.839,0,0,0,1.107.5l1.995-.8a.847.847,0,0,0,.478-1.067",
    transform: "translate(-0.537 -134.116)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18229",
    "data-name": "Path 18229",
    d: "M299.035,85.936l-1.691,1.026a.928.928,0,0,0-.333,1.227,36.171,36.171,0,0,1,2.773,7.024.925.925,0,0,0,1.085.664l1.957-.424a.927.927,0,0,0,.692-1.16,40.661,40.661,0,0,0-3.186-7.993.924.924,0,0,0-1.3-.365",
    transform: "translate(-224.926 -65.001)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18230",
    "data-name": "Path 18230",
    d: "M285.5,183.313l-1.886-.223a.858.858,0,0,0-.943.711,31.5,31.5,0,0,1-1.844,6.418.86.86,0,0,0,.418,1.105l1.724.825a.856.856,0,0,0,1.162-.454,35.623,35.623,0,0,0,2.11-7.38.859.859,0,0,0-.741-1",
    transform: "translate(-212.697 -138.7)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18231",
    "data-name": "Path 18231",
    d: "M.882,135.012l2.16-.1a.846.846,0,0,0,.8-.851,36.318,36.318,0,0,1,.936-8.124.846.846,0,0,0-.586-1.008l-2.088-.6a.838.838,0,0,0-1.049.608A39.679,39.679,0,0,0,0,134.181a.839.839,0,0,0,.881.83",
    transform: "translate(0 -94.163)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18232",
    "data-name": "Path 18232",
    d: "M136.685,25.939a35.068,35.068,0,0,0-7.646,1.029.846.846,0,0,0-.608,1.066l.56,1.841a.844.844,0,0,0,1.016.569,31.06,31.06,0,0,1,6.641-.895.846.846,0,0,0,.829-.816l.059-1.925a.84.84,0,0,0-.851-.869",
    transform: "translate(-97.268 -19.651)",
    fill: "#06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18233",
    "data-name": "Path 18233",
    d: "M65.26,56.161,67.2,57.624a.835.835,0,0,0,1.129-.155A27.184,27.184,0,0,1,75.358,51.3a27.878,27.878,0,0,1,4.364-2.169.848.848,0,0,0,.508-1.038l-.933-2.2a.844.844,0,0,0-1.113-.535,31.6,31.6,0,0,0-5.074,2.488,30.627,30.627,0,0,0-8.021,7.1.847.847,0,0,0,.171,1.224",
    transform: "translate(-49.168 -34.314)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18234",
    "data-name": "Path 18234",
    d: "M266.146,105.668l-1.862.914a.919.919,0,0,0-.35,1.189,27.683,27.683,0,0,1,1.727,4.372.917.917,0,0,0,1.075.626l2.07-.37a.928.928,0,0,0,.688-1.172,31.393,31.393,0,0,0-2.038-5.177.925.925,0,0,0-1.309-.381",
    transform: "translate(-199.879 -79.949)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18235",
    "data-name": "Path 18235",
    d: "M73.041,111.193,70.9,109.851a.844.844,0,0,0-1.207.269,26.4,26.4,0,0,0-2.03,4.28.846.846,0,0,0,.556,1.107l2.373.84a.836.836,0,0,0,1.016-.506,22.326,22.326,0,0,1,1.683-3.535.838.838,0,0,0-.25-1.112",
    transform: "translate(-51.22 -83.107)",
    fill: "#0ff2a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18236",
    "data-name": "Path 18236",
    d: "M73.628,206.423l.5.673a.841.841,0,0,0,1.224.136l2.014-1.471a.84.84,0,0,0,.134-1.131,22.2,22.2,0,0,1-2.025-3.328.836.836,0,0,0-1.062-.4l-2.3,1a.846.846,0,0,0-.444,1.157c.348.711.725,1.4,1.14,2.077.25.414.521.831.792,1.248.01.015.02.03.031.044",
    transform: "translate(-54.226 -152.152)",
    fill: "#0ff2a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18237",
    "data-name": "Path 18237",
    d: "M152.912,278l-.25-2.237a.86.86,0,0,0-.9-.749,26.546,26.546,0,0,1-5.23-.169.859.859,0,0,0-.949.692l-.366,2.224a.869.869,0,0,0,.741,1.028,30.2,30.2,0,0,0,6.154.191.869.869,0,0,0,.8-.98",
    transform: "translate(-109.998 -208.209)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18238",
    "data-name": "Path 18238",
    d: "M43.605,181a27.28,27.28,0,0,1-1.138-5.159.838.838,0,0,0-.877-.729l-2.288.1a.847.847,0,0,0-.793.949,30.974,30.974,0,0,0,1.348,6.055.845.845,0,0,0,1.113.527l2.142-.707A.839.839,0,0,0,43.605,181",
    transform: "translate(-29.169 -132.661)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18239",
    "data-name": "Path 18239",
    d: "M41.792,135.428l-2.2-.528a.845.845,0,0,0-1.056.635,30.6,30.6,0,0,0-.718,6.179.845.845,0,0,0,.885.862l2.284-.1a.837.837,0,0,0,.8-.818,26.377,26.377,0,0,1,.6-5.254.838.838,0,0,0-.592-.978",
    transform: "translate(-28.647 -102.172)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18240",
    "data-name": "Path 18240",
    d: "M145.473,66.238l.057-2.446a.845.845,0,0,0-.883-.871,26.2,26.2,0,0,0-4.679.628.846.846,0,0,0-.623,1.072l.5,2.367a.836.836,0,0,0,.974.577,23.536,23.536,0,0,1,3.863-.515.837.837,0,0,0,.79-.812",
    transform: "translate(-105.537 -47.666)",
    fill: "#0ff2a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18241",
    "data-name": "Path 18241",
    d: "M275.769,149.95l2.216.213a.87.87,0,0,0,.965-.826,30.559,30.559,0,0,0-.312-6.167.87.87,0,0,0-1.042-.723l-2.18.394a.862.862,0,0,0-.673.966,26.588,26.588,0,0,1,.259,5.25.862.862,0,0,0,.766.893",
    transform: "translate(-208.132 -107.899)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18242",
    "data-name": "Path 18242",
    d: "M209.9,227.156a.849.849,0,0,0-1.149-.042,23.464,23.464,0,0,1-3.1,2.264l-.007,0a.856.856,0,0,0-.337,1.122l1.477,2.232a.854.854,0,0,0,1.2.356l.152-.092a26.684,26.684,0,0,0,3.644-2.673.86.86,0,0,0,.044-1.263Z",
    transform: "translate(-155.471 -171.902)",
    fill: "#0ff2a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18243",
    "data-name": "Path 18243",
    d: "M248.395,222.7l1.721,1.7a.857.857,0,0,0,1.252-.057,30.968,30.968,0,0,0,3.558-5.089.86.86,0,0,0-.376-1.2l-2.08-1.183a.849.849,0,0,0-1.1.343,27,27,0,0,1-3.027,4.323.852.852,0,0,0,.056,1.158",
    transform: "translate(-187.983 -164.235)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18244",
    "data-name": "Path 18244",
    d: "M180.2,42.225l.62-2.01a.928.928,0,0,0-.6-1.213,30.85,30.85,0,0,0-5.9-1.2.926.926,0,0,0-1.022.892l-.054,2.128a.918.918,0,0,0,.816.945,26.666,26.666,0,0,1,5.016,1.016.917.917,0,0,0,1.121-.559",
    transform: "translate(-131.25 -28.636)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18245",
    "data-name": "Path 18245",
    d: "M183.328,269.4l.619,2.234a.858.858,0,0,0,1.02.724,29.845,29.845,0,0,0,5.915-1.822.86.86,0,0,0,.437-1.175L190.1,267.3a.849.849,0,0,0-1.087-.408,25.809,25.809,0,0,1-5.023,1.561.85.85,0,0,0-.667.951",
    transform: "translate(-138.879 -202.138)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18246",
    "data-name": "Path 18246",
    d: "M204.649,76.225l1.34-1.906a.928.928,0,0,0-.178-1.349,26.2,26.2,0,0,0-3.922-2.3.924.924,0,0,0-1.261.509l-.913,2.184a.92.92,0,0,0,.461,1.156,23.6,23.6,0,0,1,3.247,1.876.916.916,0,0,0,1.225-.173",
    transform: "translate(-151.255 -53.472)",
    fill: "#0ff2a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18247",
    "data-name": "Path 18247",
    d: "M245.677,182.974l2.246,1.1a.857.857,0,0,0,1.172-.465,25.914,25.914,0,0,0,1.288-4.515.859.859,0,0,0-.741-1.016l-2.416-.563a.85.85,0,0,0-.934.679,23.469,23.469,0,0,1-1.045,3.72.852.852,0,0,0,.431,1.06",
    transform: "translate(-185.753 -134.477)",
    fill: "#0ff2a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18248",
    "data-name": "Path 18248",
    d: "M243.932,78.9l.021.029a.928.928,0,0,0,1.236.261l1.85-1.273a.929.929,0,0,0,.277-1.318,30.849,30.849,0,0,0-4.208-4.95.925.925,0,0,0-1.35.072l-1.49,1.713a.92.92,0,0,0,.07,1.258,26.276,26.276,0,0,1,3.592,4.208",
    transform: "translate(-181.86 -54.085)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18249",
    "data-name": "Path 18249",
    d: "M113.555,269l.363-2.2a.861.861,0,0,0-.612-1,26.715,26.715,0,0,1-4.9-1.856.858.858,0,0,0-1.12.346l-.943,1.993a.87.87,0,0,0,.368,1.214,30.214,30.214,0,0,0,5.768,2.176.867.867,0,0,0,1.077-.668",
    transform: "translate(-80.474 -199.887)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18250",
    "data-name": "Path 18250",
    d: "M79.443,248.286l1.309-1.994a.862.862,0,0,0-.256-1.146,26.629,26.629,0,0,1-4.042-3.343.858.858,0,0,0-1.171-.037l-1.784,1.6a.87.87,0,0,0-.043,1.27,30.7,30.7,0,0,0,4.753,3.934.867.867,0,0,0,1.234-.282",
    transform: "translate(-55.456 -182.995)",
    fill: "#00dcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18251",
    "data-name": "Path 18251",
    d: "M274.468,50.243a45.393,45.393,0,0,0-6.012-7,.919.919,0,0,0-1.323.067l-1.254,1.433a.923.923,0,0,0,.056,1.28,36.754,36.754,0,0,1,5.187,6.044c.085.115.159.224.227.331a.917.917,0,0,0,1.255.279l1.647-1.021A.921.921,0,0,0,274.5,50.3l-.041-.05Z",
    transform: "translate(-201.248 -32.571)",
    fill: "#06f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_11844",
    "data-name": "Group 11844",
    transform: "translate(-466 -1076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18252",
    "data-name": "Path 18252",
    d: "M0,34.514V3.193A2.613,2.613,0,0,1,2.658.627V34.514Z",
    transform: "translate(576 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18253",
    "data-name": "Path 18253",
    d: "M17.273.627,40.894,28.656V3.193A2.614,2.614,0,0,1,43.553.627V34.514H42.5L18.827,6.533v27.98H16.119V1.74A1.134,1.134,0,0,1,17.273.627Z",
    transform: "translate(574.073 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18254",
    "data-name": "Path 18254",
    d: "M63.142,16.746H83.354v2.47H63.142V34.562H60.434V3.426a2.852,2.852,0,0,1,2.9-2.8H84.056V3.241H63.142Z",
    transform: "translate(568.772 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18255",
    "data-name": "Path 18255",
    d: "M133.206,17.524C133.156,26.432,127.288,35,115.5,35S97.8,26.383,97.8,17.427C97.8,8.327,103.667,0,115.5,0s17.754,8.375,17.7,17.524m-32.749-.048c.05,7.648,5.065,15.1,15.045,15.1,10.031,0,15.1-7.456,15.1-15.1,0-7.842-5.016-15.055-15.1-15.055s-15.1,7.068-15.045,15.055",
    transform: "translate(564.304 1098.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18256",
    "data-name": "Path 18256",
    d: "M169.066,3.807a5.662,5.662,0,0,0-10.178,0l-14.27,30.707h7.172l3.009-6.39,2.668-5.955h-.01l6.52-14.426L170.5,22.169h0l3.165,7.042,2.455,5.3h7.222Z",
    transform: "translate(558.705 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18257",
    "data-name": "Path 18257",
    d: "M195.711,34.514V3.143A2.563,2.563,0,0,1,198.318.627h3.964V34.514Z",
    transform: "translate(552.595 1098.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18258",
    "data-name": "Path 18258",
    d: "M245.659,34.506h-7.874l-10.23-11.328h-6.369V34.506h-6.621V3.093a2.565,2.565,0,0,1,2.613-2.52c4.7.011,9.392.046,14.088.046,8.275.048,12.637,5.373,12.637,11.23,0,4.648-2.206,9.344-8.876,10.651L245.659,34.07ZM221.186,6.573V17.416h10.081c4.213,0,6.018-2.71,6.018-5.421s-1.856-5.423-6.018-5.423Z",
    transform: "translate(550.341 1098.455)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMainDark);
export default __webpack_public_path__ + "static/media/logo-main-dark.2a440c6221b87c7446c21bb7047ba5f2.svg";
export { ForwardRef as ReactComponent };